(function () {

  function dispatchCartUpdated() {
    // SlideoutCart in cart-drawer.liquid listens to this
    document.dispatchEvent(new CustomEvent("cart:item-added"));
  }

  function addVariantToCart(variantId, quantity, sellingPlanId) {
    var payload = {
      id: Number(variantId),
      quantity: quantity || 1
    };

    // Attach Recharge selling plan if present
    if (sellingPlanId) {
      payload.selling_plan = Number(sellingPlanId);
    }

    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        dispatchCartUpdated();
      })
      .catch(function (err) {
        console.error("Error adding to cart", err);
      });
  }

  // Kept for potential future usage (not bound to drawer now)
  function changeCartLine(line, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        dispatchCartUpdated();
      })
      .catch(function (err) {
        console.error("Error updating cart line", err);
      });
  }

  /* ===============================
     PRODUCT PAGE FORMS (PDP AJAX)
     =============================== */

  function interceptProductForms() {
    var forms = document.querySelectorAll("form[data-product-form]");
    if (!forms.length) return;

    forms.forEach(function (form) {
      // Avoid double-binding
      if (form.dataset.dreemBound === "true") return;
      form.dataset.dreemBound = "true";

      form.addEventListener("submit", function (event) {
        try {
          event.preventDefault();
        } catch (e) {}

        var formData = new FormData(form);

        fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Accept": "application/json"
          },
          body: formData
        })
          .then(function (res) {
            return res.json();
          })
          .then(function () {
            // PDP add respects Recharge because selling_plan is in the form
            dispatchCartUpdated();
          })
          .catch(function (err) {
            console.error("Error in product form AJAX add", err);
            // Fallback
            form.removeAttribute("data-dreem-bound");
            window.location.href = "/cart";
          });
      });
    });
  }

  var quickAddState = {
    product: null,
    variants: [],
    selectedVariantId: null
  };

  function getQuickAddModal() {
    return document.getElementById("QuickAddModal");
  }

  function openQuickAddModal() {
    var modal = getQuickAddModal();
    if (!modal) return;
    modal.classList.add("is-open");

    // 🔥 Re-init Recharge widget for this modal content
    try {
      if (window.ReCharge && typeof window.ReCharge.init === "function") {
        window.ReCharge.init();
      }
      // Some setups listen to this custom event
      document.dispatchEvent(new Event("recharge:widget:mount"));
    } catch (e) {
      console.warn("Recharge re-init error in Quick Add modal", e);
    }
  }

  function closeQuickAddModal() {
    var modal = getQuickAddModal();
    if (!modal) return;
    modal.classList.remove("is-open");
  }

  function fetchProduct(handle) {
    return fetch("/products/" + handle + ".js", {
      credentials: "same-origin"
    }).then(function (res) {
      return res.json();
    });
  }

  function formatMoney(cents) {
    if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, Shopify.money_format);
    }
    var value = (cents / 100).toFixed(2);
    return "£" + value;
  }

function renderQuickAddModal(product) {
  var modal = getQuickAddModal();
  if (!modal) return;

  quickAddState.product = product;
  quickAddState.variants = product.variants || [];
  quickAddState.selectedVariantId =
    product.variants && product.variants[0] ? product.variants[0].id : null;

  var imgEl = modal.querySelector("#QuickAddModal-Image");
  var titleEl = modal.querySelector("#QuickAddModal-Title");
  var subtitleEl = modal.querySelector("#QuickAddModal-Subtitle");
  var priceEl = modal.querySelector("#QuickAddModal-Price");
  var selectEl = modal.querySelector("#QuickAddModal-VariantSelect");
  var qtyEl = modal.querySelector("#QuickAddModal-Qty");
  var viewDetailsEl = modal.querySelector("#QuickAddModal-ViewDetails");

  if (imgEl) {
    if (product.images && product.images[0]) {
      imgEl.src = product.images[0];
      imgEl.alt = product.title;
    } else {
      imgEl.removeAttribute("src");
      imgEl.removeAttribute("alt");
    }
  }

  if (titleEl) titleEl.textContent = product.title || "";
  if (subtitleEl) subtitleEl.textContent = product.vendor || "";
  if (priceEl) {
    var firstVariant = product.variants && product.variants[0];
    if (firstVariant) {
      priceEl.textContent = formatMoney(firstVariant.price);
    } else {
      priceEl.textContent = "";
    }
  }

  // 🔗 Set "View Full Details" href
  if (viewDetailsEl) {
    // product.url should be present in /products/<handle>.js
    var productUrl = product.url || ("/products/" + product.handle);
    viewDetailsEl.setAttribute("href", productUrl);
  }

  if (selectEl) {
    selectEl.innerHTML = "";

    if (product.variants && product.variants.length > 1) {
      product.variants.forEach(function (variant) {
        var opt = document.createElement("option");
        opt.value = variant.id;
        opt.textContent =
          (variant.title === "Default Title" ? "Default" : variant.title) +
          " - " +
          formatMoney(variant.price);

        if (!variant.available) {
          opt.disabled = true;
          opt.textContent += " (Sold out)";
        }

        selectEl.appendChild(opt);
      });

      quickAddState.selectedVariantId = product.variants[0].id;

      selectEl.addEventListener("change", function () {
        quickAddState.selectedVariantId = this.value;
      });
    } else if (product.variants && product.variants.length === 1) {
      var only = product.variants[0];
      var optOne = document.createElement("option");
      optOne.value = only.id;
      optOne.textContent =
        only.title === "Default Title" ? "Default" : only.title;
      selectEl.appendChild(optOne);
      quickAddState.selectedVariantId = only.id;
    }
  }

  if (qtyEl) {
    qtyEl.value = "1";
  }
}

  function initQuickAdd() {
    var modal = getQuickAddModal();
    if (!modal) return;

    // Open quick add from PLP buttons
    document.querySelectorAll("a[data-quick-add], button[data-quick-add]").forEach(function (link) {
      link.addEventListener("click", function (ev) {
        ev.preventDefault();
        var handle = this.getAttribute("data-product-handle");
        if (!handle) return;

        fetchProduct(handle)
          .then(function (product) {
            renderQuickAddModal(product);
            openQuickAddModal();
          })
          .catch(function (err) {
            console.error("Error loading product for quick add", err);
          });
      });
    });

    // Close modal handlers
    modal.addEventListener("click", function (ev) {
      if (ev.target.matches("[data-quick-add-close]") || ev.target === modal) {
        closeQuickAddModal();
      }
    });

    var closeBtn = modal.querySelector(".quick-add-modal__close");
    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        closeQuickAddModal();
      });
    }

    // Qty controls
    var qtyInput = modal.querySelector("#QuickAddModal-Qty");
    var minusBtn = modal.querySelector("[data-quick-add-qty-minus]");
    var plusBtn = modal.querySelector("[data-quick-add-qty-plus]");

    if (minusBtn && qtyInput) {
      minusBtn.addEventListener("click", function () {
        var current = parseInt(qtyInput.value, 10) || 1;
        current = current - 1;
        if (current < 1) current = 1;
        qtyInput.value = String(current);
      });
    }

    if (plusBtn && qtyInput) {
      plusBtn.addEventListener("click", function () {
        var current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = String(current + 1);
      });
    }

    // Submit "Add to Bag" with Recharge support
    var submitBtn = modal.querySelector("[data-quick-add-submit]");
    if (submitBtn) {
      submitBtn.addEventListener("click", function () {
        var qtyInput = modal.querySelector("#QuickAddModal-Qty");
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        var variantId = quickAddState.selectedVariantId;

        if (!variantId) {
          console.warn("No variant selected in Quick Add modal");
          return;
        }

        // 🔥 Detect selling plan from Recharge widget in the modal
        var sellingPlanInput =
          modal.querySelector('input[name="selling_plan"]:checked') ||
          modal.querySelector('select[name="selling_plan"]') ||
          modal.querySelector('input[name="selling_plan_id"]:checked') ||
          modal.querySelector('select[name="selling_plan_id"]') ||
          modal.querySelector('input[name="selling_plan[]"]:checked');

        var sellingPlanId = sellingPlanInput && sellingPlanInput.value
          ? sellingPlanInput.value
          : null;

        addVariantToCart(variantId, qty, sellingPlanId).then(function () {
          closeQuickAddModal();
        });
      });
    }
  }

  function interceptDataCartAdd() {
    document.querySelectorAll("[data-cart-add]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var variantId = this.getAttribute("data-variant-id");
        if (!variantId) return;

        // Try to find a selling plan within the same card/parent, if any
        var container = this.closest("[data-product-item]") || this.parentElement;
        var sellingPlanId = null;

        if (container) {
          var spInput =
            container.querySelector('input[name="selling_plan"]:checked') ||
            container.querySelector('select[name="selling_plan"]') ||
            container.querySelector('input[name="selling_plan_id"]:checked') ||
            container.querySelector('select[name="selling_plan_id"]') ||
            container.querySelector('input[name="selling_plan[]"]:checked');

          if (spInput && spInput.value) {
            sellingPlanId = spInput.value;
          }
        }

        addVariantToCart(variantId, 1, sellingPlanId);
      });
    });
  }

  function initSortAndFilters() {
    var sortSelect = document.getElementById("CollectionSortBy");
    if (sortSelect) {
      sortSelect.addEventListener("change", function () {
        var url = new URL(window.location.href);
        if (this.value) {
          url.searchParams.set("sort_by", this.value);
        } else {
          url.searchParams.delete("sort_by");
        }
        window.location.href = url.toString();
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    interceptProductForms();
    initQuickAdd();
    interceptDataCartAdd();
    initSortAndFilters();
  });
})();
